<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="硬幣使用條款" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">本使用條款（以下簡稱「Coin 使用條款」）規定了在
              <a href="https://dorima-gtchax.com/" target="_blank" >https://dorima-gtchax.com/ </a>
              上使用 Hatchi Co., Ltd.（以下簡稱「本公司」）提供的「Coin」（定義如下）（以下簡稱「服務」）的條件。</span>
            <span class="text">在考慮購買 Coin 之前，請仔細閱讀 Coin 使用條款。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 1 條 - 術語定義</span>
            <span class="text">本條款中下列各項中術語的涵義應依各項規定。</span>
            <span class="text">(1) 「服務使用協議」指有關服務使用的合約。</span>
            <span class="text">(2) 「服務使用者」係指與本公司簽訂服務使用合約的人。</span>
            <span class="text">(3) 「帳戶資訊」係指服務使用者在本服務中註冊的與服務使用者相關的資訊。</span>
            <span class="text">(4) 「貨幣」係指只能由本公司使用的貨幣。</span>
            <span class="text">(5) 「已使用餘額」係指服務使用者持有並可供使用的代幣餘額。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 2 條 - 硬幣</span>
            <span class="text">(1) 服務使用者可以按照公司指定的方法以及公司在服務中指定的價格購買可在服務中使用的硬幣。此外，公司可以為服務使用者設定購買金幣的購買單位、支付方式、使用期限以及其他購買條件，設定的購買條件和支付金額等將在本服務或公司運營的服務中公示。</span>
            <span class="text">(2) 當服務利用者依照公司規定的方式表達購買硬幣的意向時，服務利用者與公司之間應簽訂有關購買硬幣的合同，並確定購買總額。</span>
            <span class="text">(3) 若購買Coin的服務使用者是未成年人，服務使用者在購買Coin前必須獲得父母或監護人的同意。</span>
            <span class="text">(4) 如果未成年人購買代幣，公司將假定擁有父母權力的人已同意購買代幣。</span>
            <span class="text">(5) 本服務中顯示的服務使用者的使用餘額將與帳戶資訊關聯，並記錄在用於提供本服務和本公司營運的其他服務的電信設備中。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 3 條 - 硬幣的使用</span>
            <span class="text">(1)金幣可以用來購買我們的產品。</span>
            <span class="text">(2) 服務使用者可以在其Coin餘額範圍內購買本公司提供的產品。</span>
            <span class="text">(3) 若服務使用者使用Coin向本公司購買商品，則商品的價格將從Coin餘額中扣除，金額將視為已支付。</span>
            <span class="text">除非另有說明，本公司在服務範圍內向服務使用者免費發放的金幣將優先使用。</span>
            <span class="text">(4) 服務用戶可在服務內查看其Coin餘額。另外，服務使用者有責任管理和檢查幣的增減。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 4 條 - 硬幣的處理</span>
            <span class="text">(1) 當用戶在本服務中購買金幣、公司進行活動或其他情況下，本公司將依照本公司確定的方法向用戶授予金幣。硬幣購買單位、價格、有效期限和其他授予硬幣的條件將由公司決定並顯示在服務上。</span>
            <span class="text">(2) 硬幣的有效期限為自授予之日起6個月。</span>
            <span class="text">(3) 除非法律要求，否則公司不會退還用戶獲得的任何硬幣。根據法律法規要求退還硬幣時，退還方法和條件將按照公司確定的方式另行公佈。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 5 條 - 禁止兌換成現金等。</span>
            <span class="text">對於在本服務中獲得的所有內容，禁止以給予或接受金錢或其他現實世界報酬（包括但不限於所謂的 RMT [真實貨幣交易]）的形式進行任何轉讓、轉移、出借、借用等，無論是直接、透過第三方中介、網路拍賣或其他方式。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 6 條 - 硬幣轉移等</span>
            <span class="text">服務用戶不得向第三方轉讓、出借、贈送或以其他方式轉讓代幣或產品，也不得質押或以其他方式設定擔保權益。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第7條 - 停止購買和使用硬幣等</span>
            <span class="text">若服務使用者有下列情形之一，本公司可以對該服務使用者採取本公司認為適當的措施（包括但不限於暫停購買或使用Coin）。</span>
            <span class="text">(1) 若透過非法手段取得或使用貨幣或產品</span>
            <span class="text">(2) 若服務使用者違反本使用條款</span>
            <span class="text">(3) 本公司認為服務利用者使用本服務不適當的其他情況。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">成立於2025年2月28日</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
